import { useRegionalizationContext } from '../contexts/RegionalizationContext'
import { useStoreContext } from '../contexts/StoreContext'

export function useTabloidsFindProps() {
  const { postalCode } = useRegionalizationContext()
  const { salesChannels } = useStoreContext()

  return { postalCode, salesChannels }
}
